import { AfterContentInit, AfterViewInit, Component, Injector, ElementRef, EventEmitter, Input, Output, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

import { Translations } from './cardform.translation';
import { UiComponent } from '../ui/ui.component';

import { fadeInAnimation } from './fadein.animation';

declare const $: any;

const options = {
  positionClass: 'toast-bottom-right',
  progressBar: true,
  closeButton: true
};

@Component({
  selector: 'cardform',
  template: `
    <div class="card container-fluid cardform-container" [ngClass]="{'card-modal': modal}">
      <div class="sticky card-header cardform-header">
        <a #btnBack id="btnBack" name="btnBack" data-toggle="tooltip" title="{{ ui.back }}" class="navbar-btn float-left waves-effect waves-light"
          (click)="goBack()" *ngIf="backLink != null && !modal">
          <i class="fa fa-arrow-left fa-lg"></i>
        </a>
        <div class="fixed-action-btn smooth-scroll" style="bottom: 22px; right: 12px;">
          <a (click)="scrollTop()" id="returnToTop" class="btn-floating btn-small red">
            <i class="fa fa-lg fa-arrow-up"></i>
          </a>
        </div>
        <h5 class="card-title float-left">
          <i *ngIf="modal" class="{{glyph}}" style="color: #007bff !important"></i>
          <span style="display: inline-flex;">
            <b class="d-none d-md-flex" style="padding-right: 0.2rem;">{{title}}</b>
            <font color="#007bff">
              <b>{{caption}}</b>
            </font>
          </span>
          <i *ngIf="locked" class="fa fa-lock" style="color: rgba(0, 0, 0, 0.54) !important;" data-toggle="tooltip" title="{{ ui.lock }}"></i>
        </h5>
        <div class="text-right">
          <div class="btn-group">
            <a #btnSave [hidden]="locked" data-toggle="tooltip" title="{{ ui.save }}" class="navbar-btn waves-effect waves-light" (click)="onSubmit()">
              <i class="fa fa-check fa-lg"></i>
            </a>
            <a #btnCreate *ngIf="id > 0" data-toggle="tooltip" title="{{ ui.create }}" class="navbar-btn waves-effect waves-light d-none d-md-block"
              (click)="onCreate()">
              <i class="fa fa-plus fa-lg"></i>
            </a>
            <a *ngFor="let action of actions | showAction" class="navbar-btn waves-effect waves-light" (click)="action.function()">
              <i class="{{action.glyph}} fa-lg"></i>
              <span *ngIf="action.counter && action.counter() > 0" style="background-color: #ab47bc; top: 8px;" class="counter cardform-counter">
                <b>{{action.counter()}}</b>
              </span>
            </a>
            <a #btnDelete *ngIf="showDelete && id > 0" [hidden]="locked" data-toggle="tooltip" title="{{ ui.delete }}" class="navbar-btn waves-effect waves-light d-none d-md-block"
              (click)="onDelete()">
              <i class="fa fa-minus fa-lg"></i>
            </a>
            <a #btnClose *ngIf="modal" data-toggle="tooltip" title="{{ ui.close }}" class="navbar-btn waves-effect waves-light" (click)="onClose()">
              <i class="fa fa-close fa-lg"></i>
            </a>
          </div>
        </div>
      </div>
      <div class="card-block cardform-block">
        <div class="container" style="text-align: center;">
          <spinner *ngIf="loading"></spinner>
        </div>
        <error [(error)]="error"></error>
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styles: [`
    @media (max-width: 991px) { 
        .card {
            -webkit-border-radius: 0px;
            -moz-border-radius: 0px;
            -ms-border-radius: 0px;
            -o-border-radius: 0px;
            border-radius: 0px;
        }
        .card .card-header {
            -webkit-border-radius: 0px;
            -moz-border-radius: 0px;
            -ms-border-radius: 0px;
            -o-border-radius: 0px;
            border-radius: 0px;
        }
    }
    .form-header.cardform-form-header {
        margin-bottom: 2rem;
        padding: 0.5rem;
    }
    .card-title {
        margin-top: 9px;
        margin-bottom: 9px;
        color: rgba(0, 0, 0, 0.54) !important;
    }
    .navbar-btn {
        padding: .5rem 1rem;
        color: rgba(0, 0, 0, 0.54) !important;
    }
    .cardform-header {
        padding:.2rem;
        background-color: #FFF !important;
        width: 100%;
        display: block;
    }
    .cardform-block {
        padding: 0;
    }
    .cardform-content {
        padding: 1rem;
    }
    .cardform-container {
        padding: 0;
        margin-bottom: 0 !important;
    }
    .cardform-counter {
        margin-left: -6px;
        margin-top: -6px;
    }
    @media (max-width: 575px) { 
        .navbar-btn {
            margin: 0px;
        }
        .cardform-title {
            margin-right: 0px;
            margin-top: 0.1rem;
            font-size: 1rem;
        }
    }
  `],
  encapsulation: ViewEncapsulation.None,
  animations: [fadeInAnimation],
  host: { '[@fadeInAnimation]': '' }
})

export class CardFormComponent extends UiComponent {
  @Input() public title: string;
  @Input() public caption: string = '';
  @Input() public glyph: string;
  @Input() public restName: string;
  @Input() public backLink: string;
  @Input() public id: number;
  @Input() public modal: boolean = false;
  @Input() public locked: boolean = false;
  @Input() public showDelete: boolean = false;
  public error: any = null;
  public item: any = {};
  public validators: any;
  @Input() public form: FormGroup;
  public active: boolean = false;
  public loading: boolean = false;
  public formErrors: any = {};
  public displayToolbar: boolean = true;
  public validationMessages: any;
  public lastSync: Date = new Date();
  @Input() public actions: any[] = new Array<any>();
  @Output() submited: EventEmitter<any> = new EventEmitter<any>();
  @Output() created: EventEmitter<any> = new EventEmitter<any>();
  @Output() deleted: EventEmitter<any> = new EventEmitter<any>();
  @Output() reseted: EventEmitter<any> = new EventEmitter<any>();
  @Output() closed: EventEmitter<any> = new EventEmitter<any>();
  @Output() backed: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('btnBack') btnBack: ElementRef;
  @ViewChild('btnCreate') btnCreate: ElementRef;
  @ViewChild('btnDelete') btnDelete: ElementRef;
  @ViewChild('btnSave') btnSave: ElementRef;
  @ViewChild('btnClose') btnClose: ElementRef;

  constructor(
    injector: Injector,
    //public hotkeysService: HotkeysService,
    public location: Location
  ) {
    super(injector);
    this.name = 'cardform';
    this.setTranslations(Translations);
  }

  ngOnInit() {
    $('#returnToTop').fadeOut(1);
    if (!this.modal) {
      $(window).scroll(function () {
        if ($(this).scrollTop() >= 50) {
          $('#returnToTop').fadeIn(200);
        } else {
          $('#returnToTop').fadeOut(200);
        }
      });
    }
    $(".card-header").sticky({
      topSpacing: 0
      , zIndex: 3
    });
  }

  onSubmit() {
    this.submited.emit(this.item);
    this.lastSync = new Date();
  }

  onCreate() {
    this.created.emit();
  }

  onDelete() {
    this.deleted.emit();
  }

  onReset() {
    this.reseted.emit();
  }

  onClose() {
    this.closed.emit();
  }

  goBack() {
    this.backed.emit();
  }

  scrollTop() {
    if (!this.modal) {
      $('body,html').animate({
        scrollTop: 0
      }, 500);
    }
  }
}
